import React from "react";
import { inject, observer } from "mobx-react";
import gameActionOptions from "../constants/gameActionOptions";
import GameActionsDropDown from "../components/GameActionsDropDown";

class MLBGameActionDropDownContainer extends React.Component {
  render() {
    const { MLBGameActionStore } = this.props.rootStore;

    return (
      <GameActionsDropDown
        game={this.props.game}
        gameActionOptions={gameActionOptions}
        transitionToCreateIncident={
          MLBGameActionStore.trackingAccuracyReportSource
            .transitionToCreateIncident
        }
        clearClippyCache={MLBGameActionStore.clearClippyCache}
        clearStatsApiCache={MLBGameActionStore.clearStatsApiCache}
        resendGame={MLBGameActionStore.resendGame}
      />
    );
  }
}

export default inject("rootStore")(observer(MLBGameActionDropDownContainer));
